import {GET_FILTER_ENTITIES} from '../../actions/actiontypes';
import initialstate from '../initialstate';
import Utility from '../../util/utilityfunctions';
import {FilterEntityConfiguration} from '../../components/Common/CommonConfig/Config';

export default function filterDataReducer(state = initialstate.filterData, action) {
	switch (action.type) {
		case GET_FILTER_ENTITIES:
			{
				if (action.response) {
					const entityMapping = action.dataMapping || FilterEntityConfiguration[action.entityType]?.entityMapping;

					const data =
						entityMapping !== undefined && typeof entityMapping === 'function'
							? entityMapping(action.response)
							: action.response;

					return {
						...state,
						[action.key]: {
							...state[action.key],
							[action.name]: Utility.normalize(data, undefined, 'value')
						}
					};
				}
			}

			return state;

		default:
			return state;
	}
}
